export { Highlight, type HighlightProps } from './Highlight';
